"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchIsOptedInForMergedEditor = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var MERGED_EDITOR_OPTIN_STATUS = 'optins/v1/availability/mergedEmailEditor';

var fetchIsOptedInForMergedEditor = function fetchIsOptedInForMergedEditor() {
  return _apiClient.default.get(MERGED_EDITOR_OPTIN_STATUS).then(function (r) {
    return r.optedIn;
  }, function (err) {
    if (window.Raven) {
      window.Raven.captureMessage('Error fetching optin status for editor merge', {
        level: 'warning',
        err: err
      });
    }

    return false;
  });
};

exports.fetchIsOptedInForMergedEditor = fetchIsOptedInForMergedEditor;